// extracted by mini-css-extract-plugin
export default {"margins":"Profile_margins__dE0aY","heading":"Profile_heading__ETgSr"};